/*
 * Copyright (c) Nexign, JSC, 2020-2022.
 */
/**
 * Campaign page urls
 *
 * @author Yakov Gushchin
 * @version 1.21.0
 * @since 1.12.0
 */

import { CLIENT_ID, RoutePath, SUBSCRIBER_ID } from '../../../routes/constants/routesConstants';
import { ECampaignsType } from '../types';

export const getCampaignsPageUrl = (type?: ECampaignsType) => 
    type ? getCampaignUrlByType(type) : RoutePath.campaigns;

export const getCampaignsInternalPrefilterUrl = (type: ECampaignsType, id: string) => type === ECampaignsType.account
    ? RoutePath.campaignsByClient.replace(CLIENT_ID, id)
    : RoutePath.campaignsByMsisdn.replace(SUBSCRIBER_ID, id);

const getCampaignUrlByType = (type: ECampaignsType) => type === ECampaignsType.account
    ? RoutePath.campaignsAccount
    : RoutePath.campaignsSubscriber;
